"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hash_1 = __importDefault(require("@emotion/hash"));

var get_safe_value_1 = __importDefault(require("./get-safe-value"));

var PREFIX = 'ub-';

function getClassNamePrefix() {
  return PREFIX;
}

exports.getClassNamePrefix = getClassNamePrefix;

function setClassNamePrefix(prefix) {
  PREFIX = prefix;
}

exports.setClassNamePrefix = setClassNamePrefix;

function getClassName(propertyInfo, value) {
  var className = propertyInfo.className,
      _propertyInfo$safeVal = propertyInfo.safeValue,
      safeValue = _propertyInfo$safeVal === void 0 ? false : _propertyInfo$safeVal,
      _propertyInfo$complex = propertyInfo.complexValue,
      complexValue = _propertyInfo$complex === void 0 ? false : _propertyInfo$complex;
  var valueKey;

  if (value === 'inherit' || value === 'initial' || value === 'unset') {
    valueKey = value;
  } else if (complexValue || value.includes('calc(')) {
    valueKey = hash_1.default(value);
  } else if (safeValue) {
    valueKey = value;
  } else {
    valueKey = get_safe_value_1.default(value);
  }

  return "".concat(PREFIX).concat(className, "_").concat(valueKey);
}

exports.default = getClassName;